<section *ngIf="isLoanProtectionsAvailable">
  <h2 class="bl-font-size--32 bl-font-weight--900 bl-font-color--black bl-margin-bottom--16">
    {{'OlaLoanProtectionOptions/heading'|dictionary}}
  </h2>
</section>

<div *ngIf="isLoanProtectionsAvailable" class="dx-workflow-card bl-block-module bl-margin-top--16">
  <div class="bl-flex--auto">
    <div class="bl-check-wrap" [ngClass]="IsFirst ? '' : 'bl-margin-top--16'"
      *ngFor="let option of loanProtectionOptionList; index as i; first as IsFirst;">
      <input class="bl-display--inline-block" id="loanProtectionCheck{{i+1}}" type="checkbox"
        [checked]="option.isChecked" (change)="onLoanProtectionChange($event, i)">
      <label class="bl-label bl-font-color--black bl-font-weight--600 bl-font-size--14"
        for="loanProtectionCheck{{i+1}}">
        {{this.utilitiesService?.normalizeSpaces(option.question)}}
      </label>
      <div *ngIf="option.information" class="bl-padding-left--32">
        <button [attr.aria-label]="'Show more information about ' + option.heading"  class="bl-font-color--primary bl-font-weight--700 bl-text-decoration--underline"
          (click)="viewMore(option, i)" type="button" id="open-loan-protection-modal-{{i}}">
          Show more information
        </button>
      </div>
    </div>
  </div>
</div>

<ea-modal [(isModalVisible)]="showModel" openModalElementId="open-loan-protection-modal-{{modalIndex}}" [modalTitle]="modalContent?.heading">
  <p class="bl-font-size--14 modal-content-height-limit" [innerHTML]="modalContent?.information|safe:'html'"> </p>
</ea-modal>
